import type { ReactNode } from 'react';

interface NumberStepperProps {
  /** 純文字標籤；同時用於 aria-label。 */
  label: string;
  /** 顯示用標籤（可含劃線原價等 JSX）；省略時顯示 label。 */
  labelNode?: ReactNode;
  value: number;
  min?: number;
  max?: number;
  onChange: (next: number) => void;
}

/** −／＋ 數量調整器（大人 / 兒童人數）。 */
export function NumberStepper({
  label,
  labelNode,
  value,
  min = 0,
  max = 20,
  onChange,
}: NumberStepperProps): JSX.Element {
  return (
    <div className="k-row" style={{ marginBottom: 16 }}>
      <span className="k-text" style={{ fontWeight: 600 }}>
        {labelNode ?? label}
      </span>
      <div className="k-stepper">
        <button
          type="button"
          className="k-stepper__btn k-stepper__btn--minus"
          aria-label={`${label} −`}
          disabled={value <= min}
          onClick={() => onChange(Math.max(min, value - 1))}
        >
          −
        </button>
        <span className="k-stepper__value">{value}</span>
        <button
          type="button"
          className="k-stepper__btn k-stepper__btn--plus"
          aria-label={`${label} ＋`}
          disabled={value >= max}
          onClick={() => onChange(Math.min(max, value + 1))}
        >
          ＋
        </button>
      </div>
    </div>
  );
}
